'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';
import { useTour } from '../hooks/useTour';

/**
 * Auto-starts the registration tour when `?tour=registration` is in the URL.
 *
 * Used in the compliance layout to pick up the tour after navigation from
 * the dashboard Help page. Cleans the URL param after starting.
 */
export function useRegistrationTourAutoStart() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const { startTour, isActive } = useTour();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current || isActive) return;

    const tourParam = searchParams.get('tour');
    if (tourParam === 'registration') {
      startedRef.current = true;

      // Clean the tour param from the URL
      const params = new URLSearchParams(searchParams.toString());
      params.delete('tour');
      const cleanUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
      router.replace(cleanUrl);

      // Start the tour at step index 1 (skip welcome modal, already shown on dashboard)
      startTour('registration', 1);
    }
  }, [searchParams, router, pathname, startTour, isActive]);
}
